import { SET_PARENT_FORM, SET_PARENT_FORM_FIELD } from './actionTypes'

export const setParentForm = data => {
  return {
    type: SET_PARENT_FORM,
    data
  }
}

export const setParentFormField = (field, value) => {
  return {
    type: SET_PARENT_FORM_FIELD,
    field,
    value
  }
}
